import angular from 'angular';

import LinkedRetailersTableComponent from './linked-retailers-table-component';

export default angular
  .module('linked-retailers-table', [])
  .component('linkedRetailersTable', new LinkedRetailersTableComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-retailers/components/linked-retailers-table/linked-retailers-table-module.js